import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconRefresh';
/** Renders an SVG icon. */
const SvgRefresh = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M2.875 16a1.125 1.125 0 0 0 2.25 0c0-6.27 4.26-10.875 10.413-10.875 3.706 0 7.204 1.867 9.251 4.623a1.126 1.126 0 0 0 1.807-1.342c-2.462-3.314-6.623-5.531-11.058-5.531C8.028 2.875 2.875 8.607 2.875 16"
      />
      <path
        fill="currentColor"
        d="M25.029 4v4.413h-4.414a1.125 1.125 0 0 0 0 2.25h5.539a1.127 1.127 0 0 0 1.125-1.125V4a1.125 1.125 0 0 0-2.25 0m4.096 12a1.125 1.125 0 0 0-2.25 0c0 6.27-4.26 10.875-10.413 10.875-3.707 0-7.204-1.867-9.251-4.623a1.126 1.126 0 0 0-1.807 1.342c2.462 3.314 6.623 5.531 11.058 5.531 7.51 0 12.663-5.732 12.663-13.125"
      />
      <path
        fill="currentColor"
        d="M6.972 28v-4.413h4.413a1.125 1.125 0 1 0 0-2.25H5.847a1.126 1.126 0 0 0-1.125 1.125V28a1.125 1.125 0 0 0 2.25 0"
      />
    </svg>
  );
};
SvgRefresh.displayName = displayName;
export default SvgRefresh;
